

































































import { checklistPostReq } from "@/services/checklist.service";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";

export default {
  props: ["coldata", "rowdata", "item"],
  data() {
    return {
      filter1: null,
      csvimport_dialog: false,
      columnDefs: null,
      sideBar: "columns",
      rowData: null,
      defaultColDef: {},
      dialog1: false,
    };
  },
  components: {
    AgGridVue,
  },
  watch: {},
  computed: {
    appLang: function() {
      return this.$store.state.lang
    },
  },
  beforeMount() {
    this.gridOptions = {
      // EVENTS
      // Add event handlers
      onCellClicked: (event) => function (x) {},
    };

    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      enableValue: true,
      enableRowGroup: true,
      enablePivot: true,
      sortable: true,
      resizable: true,
      autoHeight: true,
      editable: true,
      filter: "agTextColumnFilter",
      // floatingFilter: true,
      /*
                // set the default column width
                //width: 150,
                // make every column editable
                // make every column use 'text' filter by default
                filter: 'agTextColumnFilter',
                // enable floating filters by default
                floatingFilter: true,
                // make columns resizable
                resizable: true,
                sideBar: null,
                // autoHeight: true,
              */
    };

    this.columnDefs = this.coldata;

    this.rowData = this.rowdata;
  },
  mounted() {
    this.csvimport_dialog = true;
  },
  destroyed() {
    //console.log("destroyed")
  },
  methods: {
    save: function () {
      //this.gridOptions.api.sizeColumnsToFit();
      console.log("save", this.item);

      this.dialog1 = true;

      //checklistPostReq("backup-action", this.item).then((resp) => {
        //  setTimeout(() => (this.dialog2 = false), 4000)
        checklistPostReq("inout-import-action", this.item).then((resp) => {
          this.dialog1 = false;
          this.closeDialog("imported");
        });
      //});

    },
    closeDialog: function (info) {
      this.$emit("dialogClosed", info);
    },
    onGridReady(params) {
      this.gridOptions.api.sizeColumnsToFit();
      console.log("oh ja");
    },
  },
};
